// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__29CGn","unreadBadge":"styles_unreadBadge__3XkIu","modalContent":"styles_modalContent__2Gm-t","modal":"styles_modal__2ntDA"};